// src/components/InitPage.js

import React, { useEffect, useState } from 'react';
import "./css/loading.css";
import animationData from './json/octopus.json';
import Lottie from 'lottie-react';
import { Spinner } from 'react-bootstrap'; // Import the Bootstrap Spinner

const InitPage = ({ language, onInitComplete }) => {
  const [progress, setProgress] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [opacity, setOpacity] = useState(1); // Control opacity
  const [scale, setScale] = useState(1); // Control zoom effect
  const [visible, setVisible] = useState(true); // Control visibility (display none)

  // Derived info for promotion
  const restaurantDisplayName =
    window.restaurantName && window.restaurantName.trim() !== ""
      ? window.restaurantName
      : "dit restaurant";

  // Link to tafelboeken.be (keeps it simple and robust, adds campaign params)
  const tafelboekenUrlBase = "https://www.tafelboeken.be";
  const tafelboekenUrl = `${tafelboekenUrlBase}/?utm_source=app&utm_medium=initpage&utm_campaign=glimlach${
    restaurantDisplayName !== "dit restaurant"
      ? `&ref=${encodeURIComponent(restaurantDisplayName)}`
      : ""
  }`;

  // Handle progress increments
  useEffect(() => {
    const timeouts = [
      setTimeout(() => setProgress(25), 1000),
      setTimeout(() => setProgress(50), 2000),
      setTimeout(() => setProgress(75), 3000),
      setTimeout(() => setProgress(100), 4000),
    ];

    return () => timeouts.forEach(clearTimeout);
  }, []);

  // Simulate loading complete
  useEffect(() => {
    const loadAnimation = () => {
      setLoaded(true);
    };

    loadAnimation();
  }, []);

  // Handle the opacity and scale transition after 3 seconds and hide after 4 seconds
  useEffect(() => {
    const fadeOutTimer = setTimeout(() => {
      setOpacity(0); // Change opacity to 0 after 3 seconds
    }, 3000);

    const hideTimer = setTimeout(() => {
      setVisible(false); // Set display to none after 4 seconds
      if (onInitComplete) {
        onInitComplete(); // Notify parent component that init is complete
      }
    }, 4000);

    return () => {
      clearTimeout(fadeOutTimer);
      clearTimeout(hideTimer);
    };
  }, [onInitComplete]);

  if (!visible) {
    return null; // Hide the component by returning null if not visible
  }

  return (
    <div
      className="loading-component"
      style={{
        display: visible ? 'flex' : 'none', // Control display with visibility state
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100vw',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        marginTop: '0',
        margin: '0',
        padding: '0',
        backgroundColor: "#eeeee4",
        position: "fixed",
        zIndex: "1000000",
        opacity: opacity, // Bind opacity to the state
        transition: 'opacity 1s ease, transform 1s ease', // Smooth transition for both opacity and scale
      }}
    >
      <div
        style={{
          transition: 'opacity 1s ease, transform 1s ease', // Smooth transition for both opacity and scale
          transform: `scale(${scale})`, // Zoom in the octopus
        }}
      >
        <Lottie
          animationData={animationData}
          loop={true}
          style={{
            height: window.innerWidth <= 768 ? '250px' : '320px',
            width: window.innerWidth <= 768 ? '250px' : '320px',
            transition: 'opacity 1s ease, transform 1s ease',
            marginTop: "-40px"
          }}
        />
      </div>
      <div style={{ marginTop: '-20px', textAlign: 'center' }}>
        <span
          className="montserrat-font"
          style={{
            fontSize: window.innerWidth <= 768 ? '13px' : '16.5px', // Smaller font size on mobile
          }}
        >
          Reserveer met een Glimlach bij {restaurantDisplayName}!
        </span>
        <div
          className="montserrat-font"
          style={{
            marginTop: '6px',
            fontSize: window.innerWidth <= 768 ? '12px' : '14px',
            opacity: 0.85
          }}
        >
          Tip: ontdek foto’s op&nbsp;
          <a
            href={tafelboekenUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="tb-promo-inline-link"
          >
            tafelboeken.be
          </a>
          .
        </div>
      </div>

      <Spinner animation="border" role="status" style={{ marginTop: '20px' }} />

      {/* Tafelboeken.be promo — pinned to bottom */}
      <div className="tb-promo-container tb-promo-footer">
        <a
          href={tafelboekenUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="tb-promo-link montserrat-font"
          aria-label="Bezoek tafelboeken.be voor reviews, foto’s en meer."
        >
          <span className="tb-emoji" aria-hidden="true">😊</span>
          <span>
          Bekijk foto's op <strong style={{textDecoration: "underline"}}>tafelboeken.be</strong>
          </span>
        </a>
      </div>
    </div>
  );
};

export default InitPage;
